import { useStacklineTheme } from '@stackline/ui';
import React, { useState } from 'react';
import ElementCard, { ElementCardProps } from 'src/components/BeaconV2Components/ElementCard/ElementCard';
import { getBrandImageUrl } from 'src/utils/image';
import _isNil from 'lodash/isNil';
import { BeaconProImageFallback } from 'src/components/SvgIcons';

export const BrandLogo = ({
  brandId,
  displayName,
  width,
  height,
  elementCardVariant
}: {
  brandId: number | string;
  width?: number | string;
  height?: number;
  displayName: string;
  elementCardVariant?: React.ComponentProps<typeof ElementCard>['variant'];
}) => {
  const theme = useStacklineTheme();

  const [error, setError] = useState(false);

  const variantSizeMapping: { [key in ElementCardProps['variant']]: string } = {
    large: '80px',
    medium: '48px',
    small: '40px',
    extraSmall: '32px'
  };

  if (error) {
    return (
      <BeaconProImageFallback
        style={{
          width: variantSizeMapping[elementCardVariant],
          height: variantSizeMapping[elementCardVariant],
          objectFit: 'cover'
        }}
      />
    );
  }

  return (
    <img
      style={{
        width: _isNil(width) ? theme.spacing.xl : width,
        height: _isNil(height) ? theme.spacing.xl : height,
        objectFit: 'contain'
      }}
      alt={displayName}
      src={getBrandImageUrl(String(brandId))}
      onError={() => setError(true)}
    />
  );
};
